var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareBlack = function SvgCompareBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 72"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 71,
    x: 0.5,
    y: 0.5,
    stroke: "#38383A",
    rx: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000008",
    fillOpacity: 0.47,
    d: "M57.412 34.388a.87.87 0 0 1 .264.641c0 .536-.378.914-.923.914-.229 0-.492-.105-.677-.28l-4.526-4.43c-.404-.387-.413-.994 0-1.38l4.526-4.43c.185-.176.448-.29.677-.29.545 0 .923.378.923.914a.88.88 0 0 1-.264.65L55.4 28.631l-1.256 1.08 1.898-.096h11.443c.528 0 .923.387.923.923s-.395.932-.923.932H56.041l-1.907-.106 1.274 1.099zm4.825 10.239 2.004-1.925 1.275-1.099-1.908.106H52.165a.896.896 0 0 1-.923-.923c0-.545.396-.931.923-.931h11.443l1.899.096-1.257-1.08-2.013-1.934a.87.87 0 0 1-.263-.642c0-.536.378-.923.923-.923.228 0 .5.114.676.29l4.527 4.43a.93.93 0 0 1 0 1.38l-4.527 4.43c-.175.175-.448.29-.676.29-.545 0-.923-.387-.923-.923 0-.255.088-.466.263-.642"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 12,
    y: 16,
    fill: "#fff",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 80,
    y: 16,
    fill: "#fff",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 12,
    y: 28,
    fill: "#FF453A",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 80,
    y: 28,
    fill: "#32D74B",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 12,
    y: 40,
    fill: "#fff",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 80,
    y: 40,
    fill: "#fff",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 12,
    y: 52,
    fill: "#fff",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 80,
    y: 52,
    fill: "#fff",
    rx: 2
  })));
};
export default SvgCompareBlack;